export function share() {
    return {
        copied: false,

        shareOn(platform) {
            const url = encodeURIComponent(this.$root.dataset.url);
            const title = encodeURIComponent(this.$root.dataset.title);
            const urls = {
                linkedin: `https://www.linkedin.com/shareArticle?mini=true&url=${url}&title=${title}`,
                facebook: `https://www.facebook.com/sharer/sharer.php?u=${url}`,
                twitter: `https://twitter.com/intent/tweet?text=${title}&url=${url}`,
            };
            if (urls[platform]) {
                window.open(urls[platform], `${platform}-share-dialog`, 'width=800,height=600');
            }
        },

        copyLink() {
            navigator.clipboard.writeText(this.$root.dataset.url).then(() => {
                this.copied = true;
                setTimeout(() => { this.copied = false; }, 2000);
            });
        },
    };
}

// Counts up from 0 to `target` once the element scrolls into view.
export function counter(target = 0, duration = 2000) {
    return {
        display: 0,
        done: false,

        init() {
            // Respect reduced-motion: show the final value immediately.
            if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
                this.display = target;
                this.done = true;
                return;
            }

            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting && !this.done) {
                        this.done = true;
                        this.run();
                        observer.unobserve(this.$el);
                    }
                });
            }, { threshold: 0.4 });

            observer.observe(this.$el);
        },

        run() {
            const start = performance.now();
            const step = (now) => {
                const progress = Math.min((now - start) / duration, 1);
                const eased = 1 - (1 - progress) * (1 - progress); // easeOutQuad
                this.display = Math.floor(eased * target);
                if (progress < 1) {
                    requestAnimationFrame(step);
                } else {
                    this.display = target;
                }
            };
            requestAnimationFrame(step);
        }
    };
}

export function menu(desktopMin = 1024) {
    // Must match the breakpoint at which the hamburger hides and the desktop nav
    // shows, per brand: ets = lg (1024), admin2win = xl (1280). Loopt dit uiteen,
    // dan staat `open` op true terwijl de CSS nog in mobiele modus zit en dekt de
    // fixed nav-overlay de hele pagina af.
    const isDesktop = () => window.innerWidth >= desktopMin;

    return {
        open: isDesktop(),
        openFilters: isDesktop(),

        init() {
            this.open = isDesktop();
            this.openFilters = isDesktop();

            window.addEventListener('resize', () => {
                this.open = isDesktop();
                this.openFilters = isDesktop();
            });
        }
    };
}